import * as React from 'react';

import classnames from 'classnames';

import styles from './plan-picker-card-selection-badge.module.css';

type Props = {
    isSelected: boolean;
    isActive: boolean;
};

export function PlanPickerCardSelectionBadge(props: Props) {
    const badge = getBadge(props.isSelected, props.isActive);
    const styleNames = classnames({
        [styles.badge]: true,
        [styles['badge-selected']]: badge && badge.level === 'selected',
        [styles['badge-unselected']]: badge && badge.level === 'unselected',
    });

    return (
        <>
            {badge && (
                <div className={styles.container}>
                    <div className={styleNames}>{badge.text}</div>
                </div>
            )}
        </>
    );
}

type Badge = {
    text: string;
    level: 'selected' | 'unselected';
};

function getBadge(isSelected: boolean, isActive: boolean): Badge | null | undefined {
    if (isSelected) {
        if (isActive) {
            return {
                text: 'Current plan',
                level: 'selected',
            };
        } else {
            return {
                text: 'Selected plan',
                level: 'selected',
            };
        }
    }

    if (!isSelected && isActive) {
        return {
            text: 'Current plan',
            level: 'unselected',
        };
    }

    return null;
}
